<template>
  <div class="order-line-items-container">
    <v-progress-circular indeterminate v-if="loading"/>
    <div class="taskTileGrid" v-else>
      <div :key="index" v-for="(task, index) in orderTasks" class="taskTileCol">
        <v-card class="lineItemCard">
          <div v-if="task.fulfilled || task.canceled" class="card-overlay">
            <v-icon color="white" size="100">mdi-cancel</v-icon>
            <h3>{{ task.fulfilled ? "Already Fulfilled" : "Canceled" }}</h3>
          </div>
          <div class="lineItemCard__head">
            <span class="lineItemCard__variant">
              {{ task.customPrintVariantName || task.printVariantName }}
            </span>
            <span
              class="lineItemCard__qty"
              :class="{ 'lineItemCard__qty--multi': (task.quantity || 1) > 1 }"
            >
              ×{{ task.quantity || 1 }}
            </span>
            <span v-if="task.express" class="lineItemCard__express">
              <v-icon x-small color="#b45309">mdi-flash</v-icon> Express
            </span>
          </div>
          <v-card-text style="position: relative">
            <TaskDetailsCard :task="task"/>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import TaskDetailsCard from "@/components/TaskCards/TaskDetailsCard";

export default {
  name: "OrderLineItems",
  components: {TaskDetailsCard},
  data() {
    return {
      loading: false,
      lineItems: [],
    };
  },
  props: {
    orderTasks: {
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.order-line-items-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 24px;
}

.card-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.36);
  color: #fff;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image {
  object-fit: contain;
}

/* Fixes 2er-Grid: immer zwei Kacheln pro Reihe (mobil eine) —
   minmax(0, 1fr) zwingt die Spaltenbreite auch gegen sperrigen
   Karten-Inhalt (min-content) durch */
.taskTileGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
  max-width: 1420px;
}
@media (max-width: 900px) {
  .taskTileGrid {
    grid-template-columns: minmax(0, 1fr);
  }
}
.taskTileCol {
  min-width: 0;
}

.lineItemCard {
  border-radius: 14px !important;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06), 0 4px 14px rgba(16, 24, 40, 0.07) !important;

  &__head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 18px 4px;
  }
  &__variant {
    font-size: 16px;
    font-weight: 700;
  }
  &__qty {
    font-size: 13px;
    font-weight: 800;
    border-radius: 999px;
    padding: 2px 12px;
    background: #f1f0f5;
    color: rgba(0, 0, 0, 0.6);

    &--multi {
      background: #7b5cd6;
      color: #fff;
    }
  }
  &__express {
    font-size: 12px;
    font-weight: 700;
    color: #b45309;
    background: #fff6e8;
    border-radius: 999px;
    padding: 2px 10px;
  }
}
</style>
